var _style, _defs, _polygon, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVieuniteLogoTextBlack01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 115.5 21.4",
    style: {
      enableBackground: "new 0 0 115.5 21.4"
    },
    width: 105,
    height: 45,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0logo{clip-path:url(#SVGID_00000134215464815904715080000001013533971649818548_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -152.3,
    y: -128.2,
    width: 419.3,
    height: 277.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000017474013622508846200000017079695307459564957_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000017474013622508846200000017079695307459564957_)"
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "8.1,19.9 0.8,1.1 5.4,1.1 10.6,15.6 15.8,1.1 20.4,1.1 13.1,19.9  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7,2.7c0-1.2,1-2.1,2.1-2.1C25,0.6,26,1.5,26,2.7s-1,2.1-2.1,2.1C22.7,4.8,21.7,3.9,21.7,2.7 M22,6.3h3.6v13.6H22 V6.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3,13.1c0-4,2.9-7.1,7.1-7.1c4.1,0,6.8,3,6.8,7.5v0.8H32.1c0.2,1.7,1.6,3.2,3.9,3.2c1.2,0,2.8-0.5,3.6-1.4l1.6,2.3 c-1.4,1.2-3.5,1.9-5.6,1.9C31.4,20.3,28.3,17.5,28.3,13.1 M35.4,8.8c-2.2,0-3.2,1.7-3.4,3h6.7C38.6,10.5,37.7,8.8,35.4,8.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54,19.9v-1.7c-0.9,1-2.6,2.1-4.8,2.1c-3,0-4.4-1.6-4.4-4.3V6.3h3.6v8.3c0,1.9,1,2.5,2.5,2.5c1.4,0,2.5-0.8,3.1-1.6V6.3 h3.6v13.6C57.6,19.9,54,19.9,54,19.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4,19.9v-8.2c0-1.9-1-2.5-2.5-2.5c-1.4,0-2.5,0.8-3.1,1.6V20h-3.6V6.3h3.6v1.8C65.6,7,67.3,6,69.5,6 c3,0,4.4,1.7,4.4,4.3v9.6C73.9,19.9,70.4,19.9,70.4,19.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1,2.7c0-1.2,1-2.1,2.1-2.1c1.2,0,2.1,0.9,2.1,2.1s-1,2.1-2.1,2.1S77.1,3.9,77.1,2.7 M77.5,6.3h3.6v13.6h-3.6V6.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3,16.6V9.4H83V6.3h2.3V2.6H89v3.7h2.8v3.1H89v6.2c0,0.8,0.5,1.5,1.2,1.5c0.5,0,1-0.2,1.2-0.4l0.8,2.7 c-0.5,0.5-1.5,0.9-3,0.9C86.7,20.3,85.3,19,85.3,16.6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3,13.1c0-4,2.9-7.1,7.1-7.1c4.1,0,6.8,3,6.8,7.5v0.8H97.1c0.2,1.7,1.6,3.2,3.9,3.2c1.2,0,2.8-0.5,3.6-1.4l1.6,2.3 c-1.4,1.2-3.5,1.9-5.6,1.9C96.4,20.3,93.3,17.5,93.3,13.1 M100.4,8.8c-2.2,0-3.2,1.7-3.4,3h6.7C103.6,10.5,102.7,8.8,100.4,8.8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M109.3,18c0-1.2,1-2.3,2.3-2.3c1.2,0,2.3,1,2.3,2.3c0,1.2-1,2.3-2.3,2.3C110.4,20.2,109.3,19.2,109.3,18"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVieuniteLogoTextBlack01);
export default __webpack_public_path__ + "static/media/Vieunite_logo_Text-black-01.89b0fa685dc9d27fbb566fe70a96014a.svg";
export { ForwardRef as ReactComponent };